// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"Page_pageContainer__AMeNP"};